import useWindowSize from "hooks/useWindowSize";
import { View } from "utils";

export type SelectorType = View.MOBILE_426 | View.TABLET_768 | View.DESKTOP_1440;

const SelectorMap = {
    [View.MOBILE_426]: (width: number) => width <= 426,
    [View.TABLET_768]: (width: number) => width === 768,
    [View.DESKTOP_1440]: (width: number) => width === 1440,
};

export const useView = (selector: SelectorType) => {
    const { width } = useWindowSize();
    return SelectorMap[selector](width);
};
